import { render, staticRenderFns } from "./ModalPopupInfo.vue?vue&type=template&id=1922f558&"
import script from "./ModalPopupInfo.vue?vue&type=script&lang=js&"
export * from "./ModalPopupInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1922f558')) {
      api.createRecord('1922f558', component.options)
    } else {
      api.reload('1922f558', component.options)
    }
    module.hot.accept("./ModalPopupInfo.vue?vue&type=template&id=1922f558&", function () {
      api.rerender('1922f558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accueil/ModalPopupInfo.vue"
export default component.exports